import { defineStore } from 'pinia'
import { ref } from 'vue'
import aplosApi from '@/services/aplosApi'
import { toast } from 'vue-sonner'
import { type User } from '@/types'
import { storeRegistry } from '@/store/storeRegistry'

export const useUserStore = defineStore('user', () => {
  const extraUserData = ref({
    tenantName: '',
    companyName: '',
    seatCount: 0
  })

  const userSettings = ref({
    execution_response_limit: 200
  })

  async function fetchUserDetails(user: User) {
    try {
      // Fetch tenant data to get tenant name and subscription info
      const { data: tenantData } = await aplosApi.getTenant(user.tenant_id)
      extraUserData.value = {
        tenantName: tenantData.name ?? '',
        companyName: tenantData.name ?? '',
        seatCount: tenantData.subscription?.seatCount ?? 0
      }
    } catch (error) {

      if (!user.roles || (user.roles?.length) == 0) {
        const message = "Authorization Error"
        console.error(message)
        toast.error(message, { duration: Infinity, 
          description: "You've logged in successfully. However, there appears to be a problem with your user account. Unfortunately, we cannot retrieve your user role. Please contact technical support or your administrator."
        } );
      } else {
        console.error('Error fetching user details:', error)
        toast.error('Unable to load user details. Some information may be unavailable.')
      }
    }
  }

  function clearUserStore() {
    extraUserData.value = {
      tenantName: '',
      companyName: '',
      seatCount: 0
    }
  }

  storeRegistry.register('user', clearUserStore)

  return { extraUserData, fetchUserDetails, userSettings, clearUserStore }
})


